<template>
  <div class="card-container">
    <p class="box-card">当前机构：{{ formModel.tatName }}</p>
    <el-card class="box-card" shadow="hover">
      <common-el-form
        :model="formModel"
        :submitData="submitData"
        @success="onSuccess"
        :SubmitButton="true"
        @cancel="onCancel"
        submit-btn-text="保存"
        failTitle="提交失败"
        loadingText="提交中..."
        :submitService="submitService"
        :showButton="false"
        labelWidth="125px"
      >
        <el-row class="flow-wrap line-bottom vertical-center" :gutter="25">
          <el-form-item label="模式">
            <el-radio-group v-model="formModel.enableGoldModel">
              <el-radio :label="0">原模式</el-radio>
              <el-radio :label="1">点金模式</el-radio>
              <el-radio :label="2">优达模式</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row class="flow-wrap line-bottom vertical-center" :gutter="25">
          <el-form-item label="达达模式辅助按钮">
            <el-switch v-model="isDaDa"> </el-switch>
          </el-form-item>
          <p class="notice-text">
            注：达达模式将辅助开启部分达达相关功能开关，如不需要可手动关闭，此按钮不涉及业务
          </p>
        </el-row>

        <el-row class="flow-wrap" :gutter="25">
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="区域代理" prop="regionProxyStatus">
              <el-switch
                v-model="formModel.regionProxyStatus"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="机构提现" prop="enableApplyWithDraw">
              <el-switch
                v-model="formModel.enableApplyWithDraw"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="机构短信" prop="enableArtificialStopSend">
              <el-switch
                v-model="formModel.enableArtificialStopSend"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="智能还款" prop="enableAutoPlan">
              <el-switch
                v-model="formModel.enableAutoPlan"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="公排管理" prop="enablePublicPlatoon">
              <el-switch
                v-model="formModel.enablePublicPlatoon"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="高级公排管理" prop="enablePublicPlatoonSenior">
              <el-switch
                :disabled="formModel.enablePublicPlatoon != 1"
                v-model="formModel.enablePublicPlatoonSenior"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="排位状态" prop="enablePublicPlatoonInfo">
              <el-switch
                :disabled="formModel.enablePublicPlatoon != 1"
                v-model="formModel.enablePublicPlatoonInfo"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="团队长" prop="enableTeamLeader">
              <el-switch
                v-model="formModel.enableTeamLeader"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="信用卡支付" prop="ccpaySwitch">
              <el-switch
                v-model="formModel.ccpaySwitch"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="积分商城" prop="integralSwitch">
              <el-switch
                v-model="formModel.integralSwitch"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="网申卡" prop="enableCreditCard">
              <el-switch
                v-model="formModel.enableCreditCard"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="卡测评" prop="enableCardEvaluation">
              <el-switch
                v-model="formModel.enableCardEvaluation"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="推广分享" prop="enablePromotion">
              <el-switch
                v-model="formModel.enablePromotion"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="卓越升级" prop="enableExcellentManage">
              <el-switch
                v-model="formModel.enableExcellentManage"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="高级卓越" prop="enableExcellentManageSenior">
              <el-switch
                :disabled="formModel.enableExcellentManage != 1"
                v-model="formModel.enableExcellentManageSenior"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="平台分红" prop="enablePlatformDividend">
              <el-switch
                v-model="formModel.enablePlatformDividend"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item
              label="会员等级层级配置"
              prop="enableMemberLevelConfiguration"
            >
              <el-switch
                v-model="formModel.enableMemberLevelConfiguration"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="会员反上级" prop="enableMemberAgainstSuperior">
              <el-switch
                v-model="formModel.enableMemberAgainstSuperior"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="导出功能" prop="enableExport">
              <el-switch
                v-model="formModel.enableExport"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="手动添加会员" prop="enableAddMembers">
              <el-switch
                v-model="formModel.enableAddMembers"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="推新奖励" prop="enableGeneraLization">
              <el-switch
                v-model="formModel.enableGeneraLization"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item
              label="等级公排管理"
              prop="enableMemLevelPublicPlatoon"
            >
              <el-switch
                v-model="formModel.enableMemLevelPublicPlatoon"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="计划随机" prop="enablePlanRandom">
              <el-switch
                v-model="formModel.enablePlanRandom"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="星钻" prop="enableStarDiamonds">
              <el-switch
                v-model="formModel.enableStarDiamonds"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="物流" prop="logisticsSwitch">
              <el-switch
                v-model="formModel.logisticsSwitch"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="轮盘抽奖" prop="lotterySwitch">
              <el-switch
                v-model="formModel.lotterySwitch"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="推荐人数换礼品" prop="enableGiftRecommend">
              <el-switch
                v-model="formModel.enableGiftRecommend"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="荣耀大天使" prop="enableGlory">
              <el-switch
                v-model="formModel.enableGlory"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="红pos达标考核" prop="enableHposUpStandard">
              <el-switch
                v-model="formModel.enableHposUpStandard"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="交易量升级" prop="enableMemlvlTransaction">
              <el-switch
                v-model="formModel.enableMemlvlTransaction"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item
              label="自动选择通道(计划)"
              prop="planAuth"
              label-width="140px"
            >
              <el-switch
                v-model="formModel.planAuth"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="还款开关" prop="enableRepay">
              <el-switch
                v-model="formModel.enableRepay"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="快捷开关" prop="enableQpay">
              <el-switch
                v-model="formModel.enableQpay"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="提现开关" prop="enableWithdraw">
              <el-switch
                v-model="formModel.enableWithdraw"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="好友账单开关" prop="friendBillSwitch">
              <el-switch
                v-model="formModel.friendBillSwitch"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="超级公排" prop="enablePublicPlatoonSuper">
              <el-switch
                v-model="formModel.enablePublicPlatoonSuper"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="云闪付开关" prop="enableYunsfPay">
              <el-switch
                v-model="formModel.enableYunsfPay"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="支付宝开关" prop="enableZhifbPay">
              <el-switch
                v-model="formModel.enableZhifbPay"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="消费优惠券" prop="enableConsumeCoupon">
              <el-switch
                v-model="formModel.enableConsumeCoupon"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">
            <el-form-item label="课程签到开关" prop="signSwitch">
              <el-switch
                v-model="formModel.signSwitch"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <div style="display: flex">
            <div>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="（ 计划最后小数" prop="planGoldModel">
                  <el-switch
                    v-model="formModel.planGoldModel"
                    active-value="1"
                    inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </div>
            <div>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item
                  label="一键切换计划"
                  prop="enableOneSwitch"
                  label-width="98px"
                >
                  <el-switch
                    v-model="formModel.enableOneSwitch"
                    active-value="1"
                    inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </div>
            <div>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item
                  label="最少绑通道数量"
                  prop="oneSwitchNumber"
                  label-width="110px"
                >
                  <el-input-number
                    :step="1"
                    :min="0"
                    :controls="false"
                    v-model="formModel.oneSwitchNumber"
                    step-strictly
                  ></el-input-number>
                  <span style="margin-left: 10px">）</span>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <div style="display: flex">
            <div>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item
                  label="试用期开关"
                  prop="enableProbation"
                  label-width="98px"
                >
                  <el-switch
                    v-model="formModel.enableProbation"
                    active-value="1"
                    inactive-value="0"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </div>
            <div>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item
                  label="试用期天数"
                  prop="probationDays"
                  label-width="110px"
                >
                  <el-input-number
                    :step="1"
                    :min="0"
                    :controls="false"
                    v-model="formModel.probationDays"
                    step-strictly
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="自定义还款天数" prop="customPlanDay">
              <el-input-number
                :step="1"
                :min="0"
                :controls="false"
                v-model="formModel.customPlanDay"
                step-strictly
              ></el-input-number>
              <span style="margin-left: 10px">天</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="提现限制金额" prop="applyWithDrawLimitMoney">
              <el-input-number
                :step="1"
                :min="0"
                :controls="false"
                v-model="formModel.applyWithDrawLimitMoney"
                step-strictly
              ></el-input-number>
              <span style="margin-left: 10px">元</span>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="公排活动提示" prop="publicPlatoonMessage">
              <el-input
                type="textarea"
                maxlength="100"
                placeholder="请输入公排活动提示"
                show-word-limit
                resize="none"
                rows="4"
                v-model="formModel.publicPlatoonMessage"
                style="width: 300px"
              ></el-input>
            </el-form-item>
          </el-col>

          <!--<el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">-->
          <!--<el-form-item label="皇冠特使" prop="crownSwitch">-->
          <!--<el-switch-->
          <!--v-model="formModel.crownSwitch"-->
          <!--active-value="1"-->
          <!--inactive-value="0">-->
          <!--</el-switch>-->
          <!--</el-form-item>-->
          <!--</el-col>-->
        </el-row>
      </common-el-form>
    </el-card>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="返利钱包" name="1">
        <el-card class="box-card" shadow="hover">
          <rebate-wallet
            :formModel="formModel"
            :organInfo="organInfo"
            @onCancel="onCancel"
            @onSuccess="onSuccess"
          ></rebate-wallet>
        </el-card>
      </el-collapse-item>
      <el-collapse-item
        :title="`领袖新星补贴 —— 已排名位数：${count}`"
        name="2"
      >
        <el-card class="box-card" shadow="hover">
          <new-reward
            ref="newReward"
            :organInfo="organInfo"
            @onCancel="onCancel"
            @onSuccess="commonSuccess"
            style="margin-bottom: 30px"
          ></new-reward>
          <new-reward-rules
            ref="newRewardRules"
            :organInfo="organInfo"
            @onCancel="onCancel"
            @onSuccess="commonSuccess"
          ></new-reward-rules>
        </el-card>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import Regs from "common/conf/Regs";
import OrganService from "service/OrganService";
import TatMemRewardsService from "service/TatMemRewardsService";
import privateKey from "service/constant/privateKey";
import RebateWallet from "@/view/fragment/OrganManage/RebateWallet";
import NewReward from "@/view/fragment/OrganManage/NewReward";
import NewRewardRules from "@/view/fragment/OrganManage/NewRewardRules";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, validatorsMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AddOrganManage",
  data() {
    return {
      formModel: {
        enableCreditCard: "0",
        enablePublicPlatoonInfo: "0",
        enableCardEvaluation: "0",
        enablePlatformDividend: "0",
        enableMemberLevelConfiguration: "0",
        enableMemberAgainstSuperior: "0",
        enableExport: "0",
        enableAddMembers: "0",
        integralSwitch: "0",
        enablePromotion: "0",
        crownSwitch: "0",
        regionProxyStatus: "0",
        enableApplyWithDraw: "0",
        enablePublicPlatoon: "0",
        enableExcellentManage: "0",
        enableTeamLeader: "0",
        ccpaySwitch: "0",
        enablePublicPlatoonSenior: "0",
        enableExcellentManageSenior: "0",
        enableGeneraLization: "0",
        enableArtificialStopSend: "1",
        enableAutoPlan: "1",
        applyWithDrawLimitMoney: "",
        customPlanDay: "",
        publicPlatoonMessage: "",
        enableMemLevelPublicPlatoon: "0",
        enablePlanRandom: "0",
        enableStarDiamonds: "0",
        logisticsSwitch: "0",
        lotterySwitch: "0",
        enableGiftRecommend: "0",
        enableGlory: "0",
        enableHposUpStandard: "0",
        enableMemlvlTransaction: "0",
        planAuth: "0",
        enableRepay: "0",
        enableQpay: "0",
        enableWithdraw: "0",
        planGoldModel: "0",
        enableOneSwitch: "0",
        oneSwitchNumber: "",
        enableProbation: "0",
        probationDays: "",
        friendBillSwitch: "0",
        enablePublicPlatoonSuper: "0",
        enableYunsfPay: "0",
        enableZhifbPay: "0",
        enableConsumeCoupon: "0",
        signSwitch: "0",
        enableGoldModel: 0,
      },
      submitService: OrganService.update,
      organInfo: {},
      activeNames: ["1", "2"],
      count: 0,
      isDaDa: false,
    };
  },
  mixins: [loadMixin, validatorsMixin],
  components: {
    CommonElForm,
    RebateWallet,
    NewReward,
    NewRewardRules,
  },
  created() {
    this.organInfo = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.getInfo();
    this.getTatRank();
  },
  computed: {
    flag() {
      return (
        Number(this.formModel.enableMemberAgainstSuperior) ||
        Number(this.formModel.enablePlatformDividend) ||
        Number(this.formModel.enableMemberLevelConfiguration) ||
        Number(this.formModel.enableExcellentManage) ||
        Number(this.formModel.enablePublicPlatoon)
      );
    },
    submitData() {
      this.isDaDa = Boolean(this.flag);
      if (this.time == null || this.time == "") {
        this.time = [];
      }

      this.params = {
        applyWithDrawLimitMoney: this.formModel.applyWithDrawLimitMoney,
        customPlanDay: this.formModel.customPlanDay,
        publicPlatoonMessage: this.formModel.publicPlatoonMessage,
        crownSwitch: this.formModel.crownSwitch,
        integralSwitch: this.formModel.integralSwitch,
        enablePromotion: this.formModel.enablePromotion,
        enableCreditCard: this.formModel.enableCreditCard,
        enableGeneraLization: this.formModel.enableGeneraLization,
        enableCardEvaluation: this.formModel.enableCardEvaluation,
        enablePlatformDividend: this.formModel.enablePlatformDividend,
        enableMemberLevelConfiguration:
          this.formModel.enableMemberLevelConfiguration,
        enableMemberAgainstSuperior: this.formModel.enableMemberAgainstSuperior,
        enableExport: this.formModel.enableExport,
        enableAddMembers: this.formModel.enableAddMembers,
        regionProxyStatus: this.formModel.regionProxyStatus,
        enablePublicPlatoon: this.formModel.enablePublicPlatoon,
        enableExcellentManage: this.formModel.enableExcellentManage,
        enableTeamLeader: this.formModel.enableTeamLeader,
        ccpaySwitch: this.formModel.ccpaySwitch,
        enablePublicPlatoonSenior: this.formModel.enablePublicPlatoonSenior,
        enablePublicPlatoonInfo: this.formModel.enablePublicPlatoonInfo,
        enableExcellentManageSenior: this.formModel.enableExcellentManageSenior,
        enableApplyWithDraw: this.formModel.enableApplyWithDraw,
        enableArtificialStopSend: this.formModel.enableArtificialStopSend,
        enableAutoPlan: this.formModel.enableAutoPlan,
        enableMemLevelPublicPlatoon: this.formModel.enableMemLevelPublicPlatoon,
        enablePlanRandom: this.formModel.enablePlanRandom,
        enableStarDiamonds: this.formModel.enableStarDiamonds,
        logisticsSwitch: this.formModel.logisticsSwitch,
        lotterySwitch: this.formModel.lotterySwitch,
        enableGiftRecommend: this.formModel.enableGiftRecommend,
        enableGlory: this.formModel.enableGlory,
        enableHposUpStandard: this.formModel.enableHposUpStandard,
        enableMemlvlTransaction: this.formModel.enableMemlvlTransaction,
        planAuth: this.formModel.planAuth,
        enableRepay: this.formModel.enableRepay,
        enableQpay: this.formModel.enableQpay,
        enableWithdraw: this.formModel.enableWithdraw,
        planGoldModel: this.formModel.planGoldModel,
        enableOneSwitch: this.formModel.enableOneSwitch,
        oneSwitchNumber: this.formModel.oneSwitchNumber,
        enableProbation: this.formModel.enableProbation,
        probationDays: this.formModel.probationDays,
        friendBillSwitch: this.formModel.friendBillSwitch,
        enablePublicPlatoonSuper: this.formModel.enablePublicPlatoonSuper,
        enableYunsfPay: this.formModel.enableYunsfPay,
        enableZhifbPay: this.formModel.enableZhifbPay,
        enableConsumeCoupon: this.formModel.enableConsumeCoupon,
        signSwitch: this.formModel.signSwitch,
        enableGoldModel: this.formModel.enableGoldModel,
        userId: this.userId,
        id: this.organInfo.id,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    isDaDa(val, oldVal) {
      // console.log(val);
      if (!val) {
        this.formModel.enableMemberAgainstSuperior = "0";
        this.formModel.enablePlatformDividend = "0";
        this.formModel.enableMemberLevelConfiguration = "0";
        this.formModel.enableExcellentManage = "0";
        this.formModel.enablePublicPlatoon = "0";
        return;
      }
      if (!this.flag) {
        this.formModel.enableMemberAgainstSuperior = "1";
        this.formModel.enablePlatformDividend = "1";
        this.formModel.enableMemberLevelConfiguration = "1";
        this.formModel.enableExcellentManage = "1";
        this.formModel.enablePublicPlatoon = "1";
      }
    },
    "formModel.enablePublicPlatoon"(val, oldVal) {
      if (val == 0) {
        this.formModel.enablePublicPlatoonSenior = "0";
        this.formModel.enablePublicPlatoonInfo = "0";
      }
    },
    "formModel.enableExcellentManage"(val, oldVal) {
      if (val == 0) {
        this.formModel.enableExcellentManageSenior = "0";
      }
    },
    "formModel.enableGoldModel"(val, oldVal) {
      // console.log(typeof (val - 0));
      this.formModel.enableGoldModel = val - 0;
      // if (val == "1") {
      //   this.formModel.enableGoldModel = true;
      // } else {
      //   this.formModel.enableGoldModel = false;
      // }
    },
    "formModel.planGoldModel"(val, oldVal) {
      if (val == 1) {
        this.formModel.enableOneSwitch = "0";
      } else {
        this.formModel.enableOneSwitch = "1";
      }
      console.log(val);
    },
    "formModel.enableOneSwitch"(val, oldVal) {
      if (val == 1) {
        this.formModel.planGoldModel = "0";
      } else {
        this.formModel.planGoldModel = "1";
      }
      console.log(val);
    },
  },
  methods: {
    getTatRank() {
      this.doLoad(
        TatMemRewardsService.getTatRank,
        {
          simpleTatId: this.organInfo.id,
          userId: this.userId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.count = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getInfo() {
      this.doLoad(
        OrganService.detail,
        {
          id: this.organInfo.id,
          userId: this.userId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            let result = res.contents;
            this.formModel = result;
            for (let i in this.formModel) {
              if (this.formModel[i]) {
                this.formModel[i] = this.formModel[i].toString();
              } else if (i == "rebateInfo" || i == "publicPlatoonMessage") {
                this.formModel[i] = "";
              } else {
                this.formModel[i] = "0";
              }
            }
            this.isDaDa = Boolean(this.flag);
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      if (res.respCode == "0000") {
        this.commonSuccess(res);
        this.getInfo();
      } else {
        this.showError(res.respMsg);
      }
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.reloadTat(true);
      this.isReloadPage(true);
    },
    onCancel() {
      this.$router.back();
    },
    ...mapActions({
      reloadTat: StorageService.Reload.tatNameList,
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
.el-form-item {
  display: flex;
  margin-right: 20px;
}

.box-card {
  margin-bottom: 30px;
}

.line-bottom {
  border-bottom: 1px dashed #e6e6e6;
  margin-bottom: 30px;
}

.notice-text {
  margin-bottom: 22px;
  color: #a3a2a2;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganManageParams.vue